module.exports = __webpack_public_path__ + "img/NHaasGroteskTXPro-75Bd.aa99adf.svg";